import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=2ca7ba80&scoped=true"
import script from "./addCase.vue?vue&type=script&lang=js"
export * from "./addCase.vue?vue&type=script&lang=js"
import style0 from "./addCase.vue?vue&type=style&index=0&id=2ca7ba80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7ba80",
  null
  
)

export default component.exports